// ----------------------------------------------------------------------

const account = {
  displayName: 'EKE Cardinal',
  email: 'ekecardinal@gmail.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
};

export default account;
